import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { getToken } from '../Auth';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export const fetchWithAuth = async (url, options = {}) => {
  const token = getToken();
  const headers = {
    ...options.headers,
    "Authorization": `Bearer ${token}`,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  return response;
};